/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

require('expose-loader?_scope.MsgBus!./modules/MsgBus');

require('expose-loader?_scope.Player!./modules/Player');

require('expose-loader?_scope.Timer!./modules/Timer');

require('expose-loader?_scope.DB!./modules/DB');

require('expose-loader?_scope.Feature!./Feature');

require('expose-loader?_scope.Room!./core/Room');

require('expose-loader?_scope.User!./core/User');

require('expose-loader?_scope.Comment!./core/Comment');

require('expose-loader?_scope.LuckyDraw!./core/LuckyDraw');

require('expose-loader?_scope.PPT!./core/PPT');

require('expose-loader?_scope.Barrage!./core/Barrage');

require('expose-loader?_scope.Vote!./core/Vote');

require('expose-loader?_scope.Signup!./core/Signup');

require('expose-loader?_scope.Signin!./core/Signin');

require('expose-loader?_scope.Topic!./core/Topic');

require('expose-loader?_scope.Redpack!./core/Redpack');

require('expose-loader?_scope.Reward!./core/Reward');

require('expose-loader?_scope.Appointment!./core/Appointment');

var _version = require('../helper/version');

var _version2 = _interopRequireDefault(_version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = {
    MsgBus: _scope.MsgBus,
    Player: _scope.Player,
    DB: _scope.DB,
    Utils: _scope.Utils,
    GetVersion: function GetVersion() {
        return _version2["default"];
    },
    Init: function Init(roomId, cb) {
        roomId = +roomId;
        if (typeof _scope.Entry === 'undefined') {
            _scope.Entry = {};
        }

        _scope.Feature.EventBus(_scope.Entry);

        _scope.MsgBus.OnMultiOnce(['Room.Init.Over', 'PPT.Inited.Over', 'User.Init.Over', 'Tracker.Init.Over', 'Comment.Init.Over'], function () {
            _scope.MsgBus.Pub('Room.User.Over');
            if (typeof cb === 'function') {
                try {
                    cb();
                } catch (e) {
                    console.warn(e); // eslint-disable-line
                }
            }
        });
        _scope.MsgBus.Sub('Room.Init.Error', function () {
            if (typeof cb === 'function') {
                try {
                    cb();
                } catch (e) {
                    console.warn(e); // eslint-disable-line
                }
            }
        });

        var user = new _scope.User({});

        var room = new _scope.Room({ id: roomId });
        var luckyDraw = new _scope.LuckyDraw();
        var barrage = new _scope.Barrage();
        var redpack = new _scope.Redpack();
        _scope.MsgBus.Pub('SendObj.User', user);
        _scope.MsgBus.Pub('SendObj.LuckyDraw', luckyDraw);
        _scope.MsgBus.Pub('SendObj.Barrage', barrage);
        _scope.MsgBus.Pub('SendObj.Room', room);
        _scope.MsgBus.Pub('SendObj.Redpack', redpack);

        room.Init();
        _scope.Entry.Room = room;
    },
    Destroy: function Destroy() {
        _scope.MsgBus.UnSubAll('SendObj.User');
        _scope.MsgBus.UnSubAll('Room.Init.Over');
        _scope.MsgBus.UnSubAll('SendObj.LuckyDraw');
        _scope.MsgBus.UnSubAll('SendObj.Barrage');
        _scope.MsgBus.UnSubAll('SendObj.Room');
        _scope.MsgBus.UnSubAll('SendObj.Redpack');
        _scope.MsgBus.Pub('Destroy');
        _scope.Entry.Room = {};
        _scope.MsgBus.Clear();
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/index.js
 ** module id = 21
 ** module chunks = 1
 **/